
const workatoResources = (code) => {

  console.info(code);
  
    const firstname = jQuery('#firstname').val();
    const lastname = 'not specified';
    const email = jQuery('#email').val();
    const company = 'not specified';
    const page = document.location.href;
    let isEmailValid = false;


    if (firstname === '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: "Please verify name",
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }
 
    if (email === '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: "Please verify Email",
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }
  
  
    emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    if (emailRegex.test(email)) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", 'https://www.workato.com/webhooks/rest/0c3c35d9-8700-4ff5-b102-53948e0f30c0/resources-form', true);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.send("email=" + email + "&firstname=" + firstname + "&lastname=" + lastname + "&company=" + company + "&code=" + code + "&page=" + page);
      xhr.onload = function(e) {
      document.location = "https://www.kometsales.com/pages/thank-you-page-resources";
      }
    } else {
      Swal.fire({
            position: 'top-end',
            type: 'error',
            title: "Please verify Email",
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }  
}

const gotoWorkatoTradeshow = (code, language) => {

    const firstname = jQuery('#firstname').val();
    const lastname = jQuery('#lastname').val();
    const email = jQuery('#email').val();
    const company = jQuery('#company').val();
    const phone = jQuery('#phone').val();
    const industry = jQuery('#industry').val();

    const page = document.location.href;

    let redirect = "";
    let msj_email = "";
    let msj_firstname = "";
    let msj_company = "";


    if (language == 'ES') {
        redirect = "https://www.kometsales.com/pages/thank-you-page-saf";
        msj_email = "Por favor verifica el Email";
        msj_firstname = "Por favor verifica el Nombre";
        msj_company = "Por favor verifica la Compañia";
    } else if (language == 'EN') {
        redirect = "https://www.kometsales.com/pages/thank-you-page-saf";
        msj_email = "Please verify email";
        msj_firstname = "Please verify firstname";
        msj_company = "Please verify company";
    }

    if (firstname == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_firstname,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }

    if (email == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_email,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }

    if (company == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_company,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }

    let xhr = new XMLHttpRequest();
    xhr.open("POST", 'https://www.workato.com/webhooks/rest/0c3c35d9-8700-4ff5-b102-53948e0f30c0/resources-form', true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send("email=" + email + "&firstname=" + firstname + "&lastname=" + lastname + "&company=" + company + "&code=" + code + "&page=" + page + "&industry=" + industry + "&phone=" + phone);
    xhr.onload = function(e) {
      
        if (language === 'ES') {
            document.location = redirect;
        }else if (language === 'EN') {
            document.location = redirect;
        }
    }
}

const gotoWorkatoResources = (code, language) => {

    const firstname = jQuery('#firstname').val();
    const lastname = jQuery('#lastname').val();
    const email = jQuery('#email').val();
    const company = jQuery('#company').val();
    const page = document.location.href;

    let redirect = "";
    let msj_email = "";
    let msj_firstname = "";
    let msj_company = "";


    if (language == 'ES') {
        redirect = "https://www.kometsales.com/pages/recurso-descargado";
        msj_email = "Por favor verifica el Email";
        msj_firstname = "Por favor verifica el Nombre";
        msj_company = "Por favor verifica la Compañia";
    } else if (language == 'EN') {
        redirect = "https://www.kometsales.com/pages/thank-you-page-resources";
        msj_email = "Please verify email";
        msj_firstname = "Please verify firstname";
        msj_company = "Please verify company";
    }



    if (firstname == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_firstname,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }

    if (email == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_email,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }

    if (company == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_company,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }




    var xhr = new XMLHttpRequest();
    xhr.open("POST", 'https://www.workato.com/webhooks/rest/0c3c35d9-8700-4ff5-b102-53948e0f30c0/resources-form', true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send("email=" + email + "&firstname=" + firstname + "&lastname=" + lastname + "&company=" + company + "&code=" + code + "&page=" + page);
    xhr.onload = function(e) {

        if (language == 'ES') {
            document.location = redirect;
        }

        if (language == 'EN') {
            document.location = redirect;
        }


    }

}

const gotoWorkatoTraining = (code, language) => {

    const firstname = jQuery('#firstname').val();
    const lastname = jQuery('#lastname').val();
    const email = jQuery('#email').val();
    const company = jQuery('#company').val();
    const page = document.location.href;

    let redirect = "";
    let msj_email = "";
    let msj_firstname = "";
    let msj_company = "";


    if (language == 'ES') {
        redirect = "https://www.kometsales.com/pages/thank-you-for-your-interest-training";
        msj_email = "Por favor verifica el Email";
        msj_firstname = "Por favor verifica el Nombre";
        msj_company = "Por favor verifica la Compañia";
    } else if (language == 'EN') {
        redirect = "https://www.kometsales.com/pages/thank-you-for-your-interest-training";
        msj_email = "Please verify email";
        msj_firstname = "Please verify firstname";
        msj_company = "Please verify company";
    }



    if (firstname == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_firstname,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }

    if (email == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_email,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }

    if (company == '') {
        Swal.fire({
            position: 'top-end',
            type: 'error',
            title: msj_company,
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }




    var xhr = new XMLHttpRequest();
    xhr.open("POST", 'https://www.workato.com/webhooks/rest/0c3c35d9-8700-4ff5-b102-53948e0f30c0/resources-form', true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send("email=" + email + "&firstname=" + firstname + "&lastname=" + lastname + "&company=" + company + "&code=" + code + "&page=" + page);
    xhr.onload = function(e) {

        if (language == 'ES') {
            document.location = redirect;
        }

        if (language == 'EN') {
            document.location = redirect;
        }


    }

}

const contactForm2 = ({ name, email, code }) => {
  
    const firstname = name;
    const lastname = 'not specified';
    const email1 = email;
    const company = 'not specified';
    let isEmailValid = false;

 if(firstname.length > 2){
   
        emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (emailRegex.test(email)) {
          var xhr = new XMLHttpRequest();
          xhr.open("POST", 'https://www.workato.com/webhooks/rest/0c3c35d9-8700-4ff5-b102-53948e0f30c0/contact-us-form-home', true);
          xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
          xhr.send(`email=${email1}&firstname=${firstname}&lastname=${lastname}&company=${company}&code=${code}`);
          xhr.onload = function(e) {
          document.location = "https://www.kometsales.com/pages/thank-you-for-your-interest";
          }
        } else {
          Swal.fire({
                position: 'top-end',
                type: 'error',
                title: "Please verify Email",
                showConfirmButton: false,
                timer: 1500
            });
            return false;
    }
       
  } else{
      Swal.fire({
            position: 'top-end',
            type: 'error',
            title: "Please verify the name",
            showConfirmButton: false,
            timer: 1500
        });
        return false;
    }
}

const workatoFormLandingPages = ({ firstname, email, code, thankyoupage }) => {
  
    const lastname = "not specified";
    const company = "not specified";
    const email1 = jQuery('#contact-form-home #email').val();
    let isEmailValid = false;    
  
     if(firstname.length > 2){

       var searchParams = new URLSearchParams({ firstname, lastname, company, email: email1, code }).toString();
            emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            if (emailRegex.test(email1)) {
              var xhr = new XMLHttpRequest();
              xhr.open("POST", 'https://www.workato.com/webhooks/rest/0c3c35d9-8700-4ff5-b102-53948e0f30c0/contact-us-form-home', true);
              xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
              xhr.send(searchParams);
              xhr.onload = function(e) {
              document.location = thankyoupage;
              }
            } else {
              Swal.fire({
                    position: 'top-end',
                    type: 'error',
                    title: "Please verify Email",
                    showConfirmButton: false,
                    timer: 1500
                });
                return false;
        }

      } 
     else{
          Swal.fire({
                position: 'top-end',
                type: 'error',
                title: "Please verify the name",
                showConfirmButton: false,
                timer: 1500
            });
            return false;
        }
}

